<template>
  <div class="d-flex align-center">
    <!-- TODO: breadcrumb should display the hierarchy of parent routes -->
    <v-icon
      :disabled="isDashboard"
      small
      color="techBlue"
      @click="onRootIconClick"
    >
      {{ rootIcon }}
    </v-icon>
    <v-icon v-if="!isDashboard" color="techBlueDark" small class="mx-1">
      mdi-chevron-right
    </v-icon>
    <div
      v-if="!isDashboard"
      :class="[
        'text-body-2',
        'text--secondary',
        { 'truncate-text': shouldTruncate },
      ]"
      :title="shouldTruncate ? label : ''"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheBreadcrumb",
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      isImpersonateEnterprise: "user/isImpersonateEnterprise",
      selectedTable: "workbook/getSelectedTable",
    }),
    rootIcon() {
      return this.isImpersonateEnterprise ? "mdi-domain" : "mdi-home";
    },
    shouldTruncate() {
      return (
        (this.$route.path.endsWith("/edit") &&
          this.selectedTable?.name === "additionalDebtCapacity") ||
        this.selectedTable?.name === "financialStatement"
      );
    },
    // disableRootIcon() {
    //   return this.isImpersonateEnterprise || this.isDashboard;
    // },
    isDashboard() {
      return this.$route.name === "dashboard";
    },
  },
  methods: {
    onRootIconClick() {
      if (!this.$route.path.endsWith("esg/eligibility-tests")) {
        if (this.$route.path.startsWith("/esg/")) {
          this.$router.push({ name: "esg.eligibility-tests.index" });
        } else if (this.$route.path.startsWith("/dsr/")) {
          if (!this.$route.name || this.$route.name !== "dsr.index") {
            this.$router.push({ name: "dsr.index" });
          }
        } else {
          const destination = this.isImpersonateEnterprise
            ? "balances"
            : "dashboard";
          if (!this.$route.path.endsWith("/" + destination)) {
            this.$router.push({ name: destination });
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.truncate-text {
  max-width: 100px; /* o quanto vuoi che sia lo spazio massimo */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
